import { timeline } from "@/mocks/home";

const stepBadge = [
  "bg-secondary-100 text-secondary-800",
  "bg-accent-100 text-accent-800",
  "bg-primary-500 text-background-50",
  "bg-secondary-100 text-secondary-800",
];

export default function EventTimeline() {
  return (
    <section id="timeline" className="border-y border-background-200/60 bg-background-100 py-16 md:py-24">
      <div className="shell">
        <div className="flex flex-col justify-between gap-5 md:flex-row md:items-end">
          <div className="border-l-2 border-primary-500 pl-4 md:pl-5">
            <span className="text-xs font-semibold tracking-[0.2em] text-primary-600">
              WATCHING IN PROGRESS · 围观进行时
            </span>
            <h2 className="mt-2 font-serif text-2xl font-bold text-foreground-950 md:text-3xl">
              一个现场，从发酵到散场
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-foreground-600">
            把同一个围观坐标按时间拉成一条线，事件进展一目了然——瓜点何时起、何时爆、何时落。
          </p>
        </div>

        <div className="relative mt-12 md:mt-16">
          <div className="absolute left-2 top-0 bottom-0 w-px bg-background-300 md:left-1/2"></div>

          <div className="flex flex-col gap-10">
            {timeline.map((s, idx) => (
              <div
                key={idx}
                className="relative grid grid-cols-1 gap-3 pl-8 md:grid-cols-2 md:gap-0 md:pl-0"
              >
                <div className="absolute left-0 top-1 flex h-4 w-4 items-center justify-center md:left-1/2 md:-translate-x-1/2">
                  <span
                    className={
                      "flex h-4 w-4 items-center justify-center rounded-full border-4 border-background-100 " +
                      (idx === 2 ? "bg-primary-500" : "bg-accent-500")
                    }
                  ></span>
                </div>

                <div
                  className={
                    "md:pr-10 " + (idx % 2 === 1 ? "md:col-start-2 md:pl-10 md:pr-0" : "md:pr-12")
                  }
                >
                  <div className="flex flex-wrap items-center gap-2.5">
                    <span className="font-serif text-2xl font-bold text-foreground-950">{s.time}</span>
                    <span
                      className={
                        "rounded-full px-2.5 py-0.5 text-[11px] " +
                        (idx === 2 ? "bg-primary-100 text-primary-700" : stepBadge[idx])
                      }
                    >
                      {s.tag}
                    </span>
                  </div>
                  <h3 className="mt-2 text-base font-bold text-foreground-950">{s.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
                </div>

                <div
                  className={
                    idx % 2 === 0 ? "hidden md:block" : "hidden md:col-start-1 md:row-start-1 md:block"
                  }
                >
                  <div className={"md:pl-10 " + (idx % 2 === 0 ? "md:text-right" : "")}>
                    {idx === 2 ? (
                      <span className="inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-3 py-1 text-xs text-background-50">
                        <i className="ri-fire-line"></i>
                        围观热度最高点
                      </span>
                    ) : (
                      <span className="inline-flex items-center gap-1.5 text-xs text-secondary-700">
                        <i className="ri-eye-line"></i>
                        现场多人围观中
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}